import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { VersionProvider } from "@/context/VersionContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Quotes from "@/pages/Quotes";
import QuoteBuilder from "@/pages/QuoteBuilder";
import QuoteView from "@/pages/QuoteView";
import Company from "@/pages/Company";
import Admin from "@/pages/Admin";
import Security from "@/pages/Security";
import Setup from "@/pages/Setup";
import Showcase from "@/pages/Showcase";
import CatalogProducts from "@/pages/CatalogProducts";

function useSourceProtection() {
  useEffect(() => {
    const blockContext = (e) => e.preventDefault();
    const blockKeys = (e) => {
      const key = (e.key || "").toLowerCase();
      // F12
      if (key === "f12") { e.preventDefault(); return; }
      // Ctrl/Cmd+Shift+I / J / C (devtools) and Ctrl/Cmd+U (view source)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && ["i", "j", "c"].includes(key)) {
        e.preventDefault();
        return;
      }
      if ((e.ctrlKey || e.metaKey) && key === "u") { e.preventDefault(); }
    };
    document.addEventListener("contextmenu", blockContext);
    document.addEventListener("keydown", blockKeys);
    return () => {
      document.removeEventListener("contextmenu", blockContext);
      document.removeEventListener("keydown", blockKeys);
    };
  }, []);
}

function App() {
  useSourceProtection();
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <VersionProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/vetrina/:token" element={<Showcase />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/quotes" element={<ProtectedRoute><Quotes /></ProtectedRoute>} />
            <Route path="/catalog" element={<ProtectedRoute><CatalogProducts /></ProtectedRoute>} />
            <Route path="/quotes/new" element={<ProtectedRoute><QuoteBuilder /></ProtectedRoute>} />
            <Route path="/quotes/:id" element={<ProtectedRoute><QuoteView /></ProtectedRoute>} />
            <Route path="/quotes/:id/edit" element={<ProtectedRoute><QuoteBuilder /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Company /></ProtectedRoute>} />
            <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
            <Route path="/security" element={<AdminRoute><Security /></AdminRoute>} />
            <Route path="/setup" element={<AdminRoute><Setup /></AdminRoute>} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
          </VersionProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
